import { Box, Card, CardContent, Typography } from "@mui/material";
import type { JSX } from "react";

import { SectionCardHeader } from "../../shared.js";

/** The mental model — how the autonomous + manual sides fit together. Static. */
export function HowItWorksCard(): JSX.Element {
  return (
    <Card data-testid="status-howitworks" sx={{ bgcolor: "surfaceSoft" }}>
      <SectionCardHeader
        title="How the agent works"
        subtitle="How the autonomous and manual sides fit together."
      />
      <CardContent sx={{ px: 2.5, py: 2, display: "grid", gap: 1.25 }}>
        <Typography sx={{ fontSize: 14 }}>
          <b>It always discovers topics.</b> Every few hours it scans industry
          news and your knowledge base and adds topics to <b>Ideas</b>.
        </Typography>
        <Box>
          <Typography sx={{ fontSize: 14, mb: 0.5 }}>
            <b>You choose how hands-on it is</b> — the <b>Mode</b> control
            (top-right):
          </Typography>
          <Box component="ul" sx={{ m: 0, pl: 2.5, display: "grid", gap: 0.25 }}>
            <Box component="li" sx={{ fontSize: 14 }}>
              <b>Manual</b> — only suggests ideas; you turn them into drafts.
            </Box>
            <Box component="li" sx={{ fontSize: 14 }}>
              <b>Review-gated</b> — drafts from the top topics into the review
              queue; nothing posts until you approve.
            </Box>
            <Box component="li" sx={{ fontSize: 14 }}>
              <b>Full autopilot</b> — drafts <i>and</i> publishes on its own,
              within the daily budget.
            </Box>
          </Box>
        </Box>
        <Typography sx={{ fontSize: 14 }}>
          <b>You can create anything yourself, anytime.</b> Write a brief in{" "}
          <b>Create New</b> (LinkedIn, X, Threads, Facebook, blog, press
          release) or generate from an <b>Idea</b> — manual work runs even while
          the agent is sleeping.
        </Typography>
        <Typography sx={{ fontSize: 14, color: "text.secondary" }}>
          It sleeps when the daily AI budget is spent and wakes at the reset;
          pause it anytime from the header.
        </Typography>
      </CardContent>
    </Card>
  );
}
